module.exports = __webpack_public_path__ + "img/logo_white_small.3879bc24.png";